/* eslint-disable react/no-array-index-key */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-conditional */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-lines */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/* eslint-disable max-len */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import { withRouter } from 'react-router';
import { TransformWrapper } from 'react-zoom-pan-pinch';

import AdditionalPictures from 'Component/AdditionalPictures';
import { DESKTOP_MIN_WIDTH } from 'Component/CategorySort/CategorySort.config';
import Image from 'Component/Image';
import { HEADER_HEIGHT } from 'Component/MenuMobile/MenuMobile.config';
import {
    BREADCRUMBS_BOTTOM,
    IMAGE_TYPE,
    MAX_ZOOM_SCALE,
    NAV_BAR_HEIGHT,
    PLACEHOLDER_TYPE,
    VIDEO_TYPE
} from 'Component/ProductGallery/ProductGallery.config';
import ProductGalleryBaseImage from 'Component/ProductGalleryBaseImage';
import ProductGalleryThumbnailImage from 'Component/ProductGalleryThumbnailImage';
import Slider from 'Component/Slider';
import VideoPopup from 'Component/VideoPopup';
import VideoThumbnail from 'Component/VideoThumbnail';
import { DeviceType } from 'Type/Device.type';
import { ProductType } from 'Type/ProductList.type';
import { LocationType } from 'Type/Router.type';
import { isArabic } from 'Util/Arabic';
import CSS from 'Util/CSS';
import isMobile from 'Util/Mobile/isMobile';
import { getBanner, handleIosStickyHeader } from 'Util/PromoBanner/PromoBanner';

import './ProductGallery.style';

/**
 * Product gallery
 * @class ProductGallery
 * @namespace Scandipwa/Component/ProductGallery/Component */
export class ProductGalleryComponent extends PureComponent {
    static propTypes = {
        gallery: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([
                    PropTypes.number,
                    PropTypes.string
                ]),
                image: PropTypes.string,
                isPlaceholder: PropTypes.bool,
                alt: PropTypes.string,
                type: PropTypes.string
            })
        ).isRequired,
        productId: PropTypes.number,
        isZoomEnabled: PropTypes.bool.isRequired,
        onActiveImageChange: PropTypes.func.isRequired,
        activeImage: PropTypes.number.isRequired,
        registerSharedElementDestination: PropTypes.func.isRequired,
        location: LocationType.isRequired,
        handleImageClick: PropTypes.func.isRequired,
        handleOverlayClose: PropTypes.func.isRequired,
        setSliderOverlayWidth: PropTypes.func,
        isSliderOverlay: PropTypes.bool,
        sliderOverlayWidth: PropTypes.number,
        // eslint-disable-next-line react/boolean-prop-naming
        areDetailsLoaded: PropTypes.bool.isRequired,
        product: ProductType.isRequired,
        setIsZoomedInState: PropTypes.func.isRequired,
        device: DeviceType.isRequired
    };

    static defaultProps = {
        productId: 0,
        sliderOverlayWidth: 0,
        setSliderOverlayWidth: {},
        isSliderOverlay: false
    };

    maxScale = MAX_ZOOM_SCALE;

    imageRef = createRef();

    sliderRef = createRef();

    sliderOverlayRef = createRef();

    sliderWidth = 0;

    shouldRemoveAnimation = false;

    animationLoadTimeout = null;

    // Timeout to handle animation timeout
    animationTimeoutTimeout = null;

    // Image passed from PLP
    preloadedImage = null;

    sharedElementWasEverDetected = false;

    updateWindowDimensions = this.updateWindowDimensions.bind(this);

    state = {
        isDesktop: false
    };

    componentDidMount() {
        this.updateSharedDestinationElement();

        const banner = getBanner();
        const bannerHeight = banner && banner.offsetHeight
        && banner.offsetHeight > window.scrollY ? banner.offsetHeight - window.scrollY : 0;

        document.documentElement.style.setProperty(
            '--slider-overlay-height',
            `${ window.innerHeight - HEADER_HEIGHT - bannerHeight }px`
        );

        document.documentElement.style.setProperty(
            '--breadcrumbs-bottom',
            `${ BREADCRUMBS_BOTTOM }px`
        );

        if (bannerHeight) {
            document.documentElement.style.setProperty(
                '--breadcrumbs-bottom',
                `${ BREADCRUMBS_BOTTOM + bannerHeight }px`
            );
        }

        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);

        this.handleScroll();
        window.addEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate(prevProps) {
        const {
            productId,
            location: { pathname },
            isSliderOverlay,
            setSliderOverlayWidth,
            activeImage
        } = this.props;

        const {
            productId: prevProductId,
            location: {
                pathname: prevPathname
            }
        } = prevProps;

        this.handleScroll();

        if (isSliderOverlay) {
            const sliderWidth = this.sliderRef.current.draggableRef.current.offsetWidth;
            const newTranslate = -activeImage * sliderWidth;

            setSliderOverlayWidth(sliderWidth);

            CSS.setVariable(
                this.sliderRef.current.draggableRef,
                'translateX',
                `${isArabic() ? Math.abs(newTranslate) : newTranslate}px`
            );
        } else if (document.documentElement.style.overflow === 'hidden') {
            document.documentElement.style.overflow = 'initial';
        }

        if (productId !== prevProductId) {
            this.updateSharedDestinationElement();
        }

        if (this.sliderRef && pathname !== prevPathname && this.sliderRef.current) {
            CSS.setVariable(
                this.sliderRef.current.draggableRef,
                'animation-speed',
                0
            );
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    __construct(props, context) {
        super.__construct(props, context);
        this.renderSlide = this.renderSlide.bind(this);
    }

    updateWindowDimensions() {
        const { isDesktop } = this.state;
        const newIsDesktop = (window.innerWidth >= DESKTOP_MIN_WIDTH);

        if (isDesktop !== newIsDesktop) {
            this.setState({ isDesktop: newIsDesktop });
        }
    }

    isLoading() {
        const {
            areDetailsLoaded,
            product: {
                thumbnail
            }
        } = this.props;

        return !areDetailsLoaded || !thumbnail;
    }

    handleScroll = () => {
        const topBanner = document.querySelector('[id^=\'global_promo_banner_\']');
        const topBannerHeight = topBanner ? topBanner.offsetHeight : 0;
        const top = window.pageYOffset > topBannerHeight
            ? NAV_BAR_HEIGHT
            : topBannerHeight + NAV_BAR_HEIGHT - window.pageYOffset;

        CSS.setVariable(
            this.sliderOverlayRef,
            'slider-overlay-top',
            `${top}px`
        );
    };

    updateSharedDestinationElement() {
        const { registerSharedElementDestination } = this.props;
        registerSharedElementDestination(this.imageRef);
    }

    renderAdditionalPicture = (media, index = 0) => {
        const { onActiveImageChange, activeImage } = this.props;
        const isLoading = this.isLoading();

        return (
            <ProductGalleryThumbnailImage
              key={ index }
              media={ media }
              index={ index }
              onActiveImageChange={ onActiveImageChange }
              isActiveImage={ Math.abs(activeImage) === index }
              isLoading={ isLoading }
            />
        );
    };

    /**
     * Renders a video thumbnail which opens popup player on click/tap
     * @param media
     * @param index
     * @returns {*}
     * @private
     */
    renderVideo(media, index) {
        return (
            <VideoThumbnail
              key={ index }
              media={ media }
            />
        );
    }

    renderPlaceholder(index) {
        return (
            <Image
              key={ index }
              ratio="custom"
              mix={ {
                  block: 'ProductGallery',
                  elem: 'SliderImage',
                  mods: { isPlaceholder: true }
              } }
              isPlaceholder
            />
        );
    }

    /**
     * Renders a product image to be displayed in the gallery
     * @param mediaData
     * @param index
     * @param isOverlay
     * @returns {*}
     * @private
     */
    renderImage(mediaData, index, isOverlay = false) {
        const {
            isSliderOverlay,
            setIsZoomedInState,
            device,
            onActiveImageChange
        } = this.props;
        const { isDesktop } = this.state;

        // eslint-disable-next-line no-magic-numbers
        const zoomScale = device.isMobile ? 3.2 : 2.2;

        return (
            <TransformWrapper
              key={ index }
              wheel={ { limitsOnWheel: true, disabled: true } }
              options={ {
                  minScale: zoomScale,
                  maxScale: zoomScale
              } }
              doubleClick={ { disabled: true } }
            >
                { ({
                    scale,
                    resetTransform,
                    setTransform,
                    zoomIn
                }) => {
                    const isNotZoomedIn = scale === 1;

                    return (
                        <ProductGalleryBaseImage
                          setTransform={ setTransform }
                          index={ index }
                          mediaData={ mediaData }
                          isNotZoomedIn={ isNotZoomedIn }
                          setIsZoomedInState={ setIsZoomedInState }
                          isSliderOverlay={ isSliderOverlay }
                          zoomIn={ zoomIn }
                          resetTransform={ resetTransform }
                          isOverlay={ isOverlay }
                          isDesktop={ !!isDesktop }
                          onActiveImageChange={ onActiveImageChange }
                        />
                    );
                } }
            </TransformWrapper>
        );
    }

    /**
     * Checks for the type of the slide and renders it accordingly
     * @param media
     * @param index
     * @param isOverlay
     * @returns {null|*}
     */
    renderSlide(isOverlay, media, index) {
        const { media_type } = media;

        switch (media_type) {
        case IMAGE_TYPE:
            return this.renderImage(media, index, isOverlay);
        case VIDEO_TYPE:
            return this.renderVideo(media, index);
        case PLACEHOLDER_TYPE:
            return this.renderPlaceholder(index);
        default:
            return null;
        }
    }

    renderAdditionalPictures() {
        const { gallery, onActiveImageChange, activeImage } = this.props;

        const isLoading = this.isLoading();

        if (gallery.length === 1) {
            return <div block="ProductGallery" elem="Additional" />;
        }

        return (
            <AdditionalPictures
              mix={ {
                  block: 'ProductGallery',
                  elem: 'Additional',
                  mods: { isLoading }
              } }
              activeImage={ Math.abs(activeImage) }
              onActiveImageChange={ onActiveImageChange }
              isLoading={ isLoading }
            >
                { gallery.map(this.renderAdditionalPicture) }
            </AdditionalPictures>
        );
    }

    renderSlider(showCrumbs = false, isOverlay = false) {
        const {
            gallery,
            isZoomEnabled,
            onActiveImageChange,
            sliderOverlayWidth,
            handleImageClick,
            activeImage,
            isSliderOverlay
        } = this.props;

        const { isDesktop } = this.state;

        return (
            <div ref={ this.imageRef }>
                <Slider
                  ref={ this.sliderRef }
                  mix={ { block: 'ProductGallery', elem: 'Slider' } }
                  showArrows={ !this.isLoading() }
                  showCrumbs={ showCrumbs }
                  activeImage={ activeImage }
                  onActiveImageChange={ onActiveImageChange }
                  isInteractionDisabled={ isZoomEnabled }
                  sliderOverlayWidth={ sliderOverlayWidth }
                  onSliderClick={ handleImageClick }
                  isDesktop={ isDesktop }
                  isPDPSlider
                  isSliderOverlay={ isSliderOverlay }
                >
                    { gallery.map(this.renderSlide.bind(this, isOverlay)) }
                </Slider>
                { isMobile.any() ? this.renderStageGlide() : null }
            </div>
        );
    }

    renderDesktopSlider() {
        const {
            gallery,
            isZoomEnabled,
            onActiveImageChange,
            sliderOverlayWidth,
            handleImageClick,
            activeImage,
            isSliderOverlay
        } = this.props;

        return (
            <Slider
              ref={ this.sliderRef }
              mix={ { block: 'ProductGallery', elem: 'Slider' } }
              showArrows={ !this.isLoading() }
              activeImage={ activeImage }
              onActiveImageChange={ onActiveImageChange }
              isInteractionDisabled={ isZoomEnabled }
              sliderOverlayWidth={ sliderOverlayWidth }
              onSliderClick={ handleImageClick }
              isDesktop
              isPDPSlider
              isSliderOverlay={ isSliderOverlay }
              isPdpDesktopSlider
            >
                { gallery.map(this.renderSlide.bind(this, false)) }
            </Slider>
        );
    }

    renderStageGlide() {
        const { gallery, activeImage } = this.props;

        if (this.isLoading()) {
            return null;
        }

        return (
            <div block="ProductGallery" elem="Glide">
                { gallery.map((media, i) => (
                            <div
                              block="ProductGallery"
                              elem="GlideStage"
                              mods={ { isActive: isArabic() ? i === Math.abs(activeImage) : i === activeImage } }
                              key={ i.toString() }
                            />
                )) }
            </div>
        );
    }

    renderCloseButton() {
        const { handleOverlayClose } = this.props;

        return (
            <div
              block="ProductGallery"
              elem="CloseButton"
              role="button"
              tabIndex="0"
              onClick={ handleOverlayClose }
              onKeyDown={ handleOverlayClose }
            >
                <svg fill="black" viewBox="0 0 15.642 15.642" id="close" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.882 7.821l6.541-6.541A.75.75 0 1 0 14.362.219L7.821 6.76 1.28.22A.75.75 0 1 0 .219 1.281L6.76 7.822l-6.54 6.54a.75.75 0 0 0 1.06 1.061l6.541-6.541 6.541 6.541a.75.75 0 1 0 1.06-1.061l-6.54-6.541z" />
                </svg>
            </div>
        );
    }

    renderSliderOverlay() {
        const { isSliderOverlay, device: { isMobile } = {} } = this.props;

        if (!isSliderOverlay) {
            return null;
        }

        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.height = '100%';
        document.body.style.overflow = 'hidden';

        if (isMobile) {
            document.documentElement.style.overflow = 'hidden';
        }

        document.addEventListener('touchmove', (e) => {
            if (window.scrollY === window.innerHeight - 1 || window.scrollY < 1) {
                e.preventDefault();
            }
        });

        handleIosStickyHeader();

        return (
            <div
              id="slider_overlay"
              block="ProductGallery"
              elem="SliderOverlay"
              mods={ { isVisible: isSliderOverlay } }
              ref={ this.sliderOverlayRef }
            >
                { this.renderCloseButton() }
                { this.renderSlider(true, true) }
            </div>
        );
    }

    render() {
        const { isSliderOverlay } = this.props;
        const { isDesktop } = this.state;

        return (
            <div block="ProductGallery">
                { isSliderOverlay && this.renderSliderOverlay() }
                { isDesktop && this.renderDesktopSlider() }
                { !isDesktop && this.renderSlider() }
                <VideoPopup />
            </div>
        );
    }
}

export default withRouter(ProductGalleryComponent);
